module.exports = __webpack_public_path__ + "img/heuristic-evaluation-2.5310268e.svg";